import http from '@root/utils/axios/admin';

let state = {
    EventsIGDBList: [],
}

let actions = {

    fetchEventsIGDBList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/source/events', { params: filter }).then((response) => {
                commit('setEventsIGDBList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    toggleShowEvent({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/source/toggle-show-event', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });
    },


}


let mutations = {
    setEventsIGDBList(state, data) {
        state.EventsIGDBList = data;
    },
}

export default {
    state,
    actions,
    mutations
}